<template>
  <div class="pages" :style="{ minHeight: height + 'px' }">
    <navTop></navTop>
    <div class="box">
      <div class="box-main">
        <div class="box-main-top">Notification reminder</div>
        <div class="box-main-bottom">
          <div class="box-main-bottom-top" v-for="(item, index) in lists" :key="index">
            <p class="p1">{{ item.userName }}</p>
            <p class="p2">{{ item.userContent }}</p>
            <p class="p3" v-if="item.isReply == 1">
              {{ item.docName ? item.docName.substr(0, 1) : '' }}inspectors reply：{{ item.docContent }}
            </p>
          </div>
          <textarea
              class="box-main-bottom-textarea"
              v-model="content"
              placeholder="Please enter, for example: time, place has changed..."
          ></textarea>
          <div class="box-main-bottom-btn" @click="subimt">Submit notification</div>
        </div>
      </div>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';
export default {
  name: 'noticeRemind',
  components: {
    navTop,
    navFooter
  },
  data() {
    return {
      height: '',
      content: '',
      id: '',
      lists: []
    };
  },
  created() {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({path: '/'});
    } else {
      this.id = this.$route.query.id;
      this.height = window.innerHeight;
      this.getNoticelist();
    }
  },
  methods: {
    getNoticelist() {
      this.$api.noticelist({id: this.id}).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.lists = res.dataList;
        }
      });
    },
    subimt() {
      if (this.content == '') {
        this.$message({
          message: 'Please enter the content of the notification',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      let data = {
        id: this.id,
        uid: sessionStorage.getItem('uid'),
        userContent: this.content
      };
      this.$api.notice(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.content = '';
          this.getNoticelist();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
    padding-top: 30px;
    padding-bottom: 80px;
    box-sizing: border-box;

    .box-main {
      width: 100%;
      border-radius: 38px;
      border: 1px solid $blue-primary-rgba;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      box-shadow: 0 0 40px $blue-glow;
      padding: 30px 0 50px;
      box-sizing: border-box;

      .box-main-top {
        width: 277px;
        height: 49px;
        font-size: 22px;
        color: #ffffff;
        line-height: 49px;
        text-align: center;
        background: linear-gradient(90deg, $blue-primary 0%, $blue-secondary 100%);
        border-radius: 0 25px 25px 0;
        padding-left: 30px;
        box-sizing: border-box;
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
        box-shadow: 0 0 20px $blue-glow;
      }

      .box-main-bottom {
        padding: 0 200px;
        box-sizing: border-box;

        .box-main-bottom-top {
          margin-bottom: 30px;
          padding: 15px;
          border-bottom: 1px dashed $blue-primary-rgba;

          .p1 {
            font-size: 16px;
            color: #c0e4ff;
            line-height: 1.2em;
            margin-bottom: 10px;
            font-weight: 500;
          }

          .p2 {
            font-size: 18px;
            color: $blue-primary;
            line-height: 1.3em;
            margin-bottom: 10px;
            word-break: break-word;
          }

          .p3 {
            margin-top: 10px;
            width: 100%;
            min-height: 60px;
            background: rgba(27, 168, 232, 0.15);
            border: 1px solid $blue-primary-rgba;
            border-radius: 10px;
            padding: 15px;
            box-sizing: border-box;
            font-size: 16px;
            color: $blue-primary;
            line-height: 1.4em;
            box-shadow: 0 0 15px $blue-glow inset;
            word-break: break-word;
          }
        }

        .box-main-bottom-textarea {
          width: 100%;
          height: 159px;
          background: rgba(27, 168, 232, 0.1);
          border: 1px solid $blue-primary;
          border-radius: 10px;
          outline: none;
          resize: none;
          padding: 17px 20px;
          box-sizing: border-box;
          font-weight: 400;
          color: $blue-primary;
          line-height: 1.5;
          margin-top: 30px;
          font-size: 16px;
          transition: all 0.3s ease;
          box-shadow: 0 0 15px $blue-glow inset;

          &:focus {
            box-shadow: 0 0 25px $blue-primary inset;
            background: rgba(27, 168, 232, 0.15);
          }
        }

        .box-main-bottom-textarea::-webkit-input-placeholder {
          color: rgba(27, 168, 232, 0.6);
        }

        .box-main-bottom-btn {
          width: 100%;
          height: 60px;
          background: linear-gradient(
                  90deg,
                  rgba(27, 168, 232, 0.8) 0%,
                  rgba(27, 168, 232, 0.6) 100%
          );
          margin-top: 30px;
          text-align: center;
          line-height: 60px;
          font-size: 22px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #ffffff;
          border-radius: 30px;
          border: 1px solid $blue-primary;
          box-shadow: 0 0 20px $blue-glow;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 5px 30px $blue-primary;
            background: linear-gradient(
                    90deg,
                    rgba(27, 168, 232, 0.9) 0%,
                    rgba(27, 168, 232, 0.7) 100%
            );
          }
        }
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      .box-main {
        .box-main-bottom {
          padding: 0 100px;

          .box-main-bottom-top {
            .p1 {
              font-size: 15px;
            }

            .p2 {
              font-size: 16px;
            }

            .p3 {
              font-size: 15px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      .box-main {
        .box-main-bottom {
          padding: 0 30px;

          .box-main-bottom-top {
            .p1 {
              font-size: 14px;
            }

            .p2 {
              font-size: 15px;
            }

            .p3 {
              font-size: 14px;
              padding: 12px;
            }
          }

          .box-main-bottom-textarea {
            height: 140px;
            font-size: 14px;
          }

          .box-main-bottom-btn {
            height: 50px;
            line-height: 50px;
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>